function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "ab"
}, React.createElement("path", {
  d: "M0 7h29v31H0z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  className: "stroke-secondary",
  strokeLinecap: "round",
  strokeMiterlimit: 50,
  strokeWidth: 2,
  d: "M25.1 8.54l5-7.2M40.13 17.26l-9.2 1.1M28.87 13.43l7.2-5.15"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#ab)"
}, React.createElement("path", {
  d: "M24.97 15.7c3.75 5.95 5.13 11.85 3.08 13.15-.6.38-1.42.33-2.38-.09a14.76 14.76 0 00-9.21-.84l-.1.02a33.9 33.9 0 00-3.72 1.1 1.09 1.09 0 00-.55 1.61l2.4 3.73c.18.32.4.6.7.83l.34.3c.17.13.06.41-.2.5l-1.1.56a7.58 7.58 0 00-1.19.77c-.29.23-.61.4-.95.53-.82.29-1.64.09-2-.5L7.2 32.8a1.07 1.07 0 00-1.48-.34h-.01l-.24.17a3.53 3.53 0 01-4.91-1.1l-.01-.02a3.58 3.58 0 011.1-4.91 34.22 34.22 0 008.91-8.34l.04-.05a14.87 14.87 0 002.94-8.61c.02-1.12.33-1.94.95-2.33 2.04-1.3 6.74 2.47 10.48 8.43m1.74 11.02c1.28-.82-.12-5.36-3.12-10.14s-6.48-8-7.76-7.17c-1.28.81.12 5.35 3.12 10.13 3 4.78 6.48 8 7.76 7.18"
}));

var SvgMegaphone = function SvgMegaphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 41 38",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMegaphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/megaphone.96d30964.svg";
export { ForwardRef as ReactComponent };